// extracted by mini-css-extract-plugin
module.exports = {"titleListAttach":"payload-list_titleListAttach__1-LCZ"};